import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("This field is required")
      .max(255, "Name must be less than 255 characters"),
    code: Yup.string()
      .trim("Cannot include leading and trailing spaces")
      .strict(true),
    service_id: Yup.string()
      .trim()
      .required("This field is required")
  }),
  mapPropsToValues: props => ({
    id:
      props && props.editedData && props.editedData.id
        ? props.editedData.id
        : "",
    name:
      props && props.editedData && props.editedData.name
        ? props.editedData.name
        : "",
    code:
      props && props.editedData && props.editedData.code
        ? props.editedData.code
        : "",
    service_id:
      props && props.editedData && props.editedData.service_id
        ? props.editedData.service_id
        : ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
